import React, { useEffect, useState } from 'react';
import { useTenantProtection } from '../../hooks/useTenantProtection';

const OpportunitiesSingleFetch = () => {
  const { getProtectedTenantCode } = useTenantProtection();
  const [status, setStatus] = useState('idle');
  const [durationMs, setDurationMs] = useState(null);
  const [rowCount, setRowCount] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const run = async () => {
      setStatus('loading');
      setError(null);
      setDurationMs(null);
      setRowCount(null);
      const start = performance.now();
      try {
        const tenantCode = getProtectedTenantCode();
        const selectedRole = localStorage.getItem('selectedRole');
        const res = await fetch('/api/opportunities?page=1&limit=20', {
          signal: controller.signal,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            ...(tenantCode ? { 'X-Tenant-Code': tenantCode } : {}),
            ...(selectedRole ? { 'X-Selected-Role': selectedRole } : {})
          }
        });
        const end = performance.now();
        setDurationMs(Math.round(end - start));
        if (!res.ok) {
          throw new Error(`Request failed: ${res.status}`);
        }
        const data = await res.json();
        const list = data?.opportunities || [];
        setRowCount(list.length);
        setStatus('success');
      } catch (err) {
        if (err?.name === 'AbortError') return;
        const end = performance.now();
        setDurationMs(Math.round(end - start));
        setError(err.message || 'Request failed');
        setStatus('error');
      }
    };
    run();
    return () => controller.abort();
  }, [getProtectedTenantCode]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 p-6">
      <div className="max-w-3xl mx-auto space-y-4">
        <h1 className="text-2xl font-semibold">Opportunities Single Fetch Test</h1>
        <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4 space-y-2">
          <div>Status: {status}</div>
          <div>Duration: {durationMs !== null ? `${durationMs} ms` : '—'}</div>
          <div>Row count: {rowCount !== null ? rowCount : '—'}</div>
          {error && <div className="text-red-600 dark:text-red-400">Error: {error}</div>}
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-400">
          This page only sends a single request to <code>/api/opportunities?page=1&amp;limit=20</code>.
        </div>
      </div>
    </div>
  );
};

export default OpportunitiesSingleFetch;
